import { Component, Prop } from "vue-property-decorator";
import Vuetify from "vuetify";
import Vue from "vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  OUTLINE_CICLE,
  TIMEOUTMODAL,
  TIMEOUTMODAL_BTN_TEXT,
  TIMEOUTMODAL_CONTENT,
  TIMEOUTMODAL_TITLE
} from "./constants/TimeOutConstants";

Vue.use(Vuetify);
@Component({
  name: "TimeOutModal",
  components: {}
})
export default class TimeOutModal extends Vue {
  @Prop() showDialog!: boolean;
  cardClass = STYLE_CLASSES.CARD;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  TIMEOUTMODAL_TITLE = TIMEOUTMODAL_TITLE;
  TIMEOUTMODAL_CONTENT = TIMEOUTMODAL_CONTENT;
  TIMEOUTMODAL_BTN_TEXT = TIMEOUTMODAL_BTN_TEXT;
  TIMEOUTMODAL = TIMEOUTMODAL;
  MAXWIDTH = 477;
  OUTLINE_CICLE = OUTLINE_CICLE;
  refreshEvents() {
    this.$emit("RefreshEvents");
  }
}
